<template>
 <div id="expense-container" class="container p-0">
   <div class="d-flex justify-content-between py-7 border-bottom p-5">
     <h1 class="fs-2hx"> {{ $t('recurrentExpense.title') }} </h1>
    <div class="d-flex flex-column align-items-end">
      <span class="fs-5 fw-semibold"> {{ $t('recurrentExpense.created_at') }} {{ new Date(recurrentExpense.created_at).toLocaleDateString() }} </span>
      <br>
      <span :class="`badge badge-${isActive ? 'success' : 'danger'}`"> {{ isActive ? $t('recurrentExpense.label.enable') : $t('recurrentExpense.label.disable') }} </span>
    </div>
   </div>
   <div class="border-top border-bottom py-10 ps-7 pe-5">
     <div class="d-flex justify-content-between">
       <div class="d-flex flex-column">
         <span class="fw-bold fs-4 text-start"> {{ $t('recurrentExpense.label.startDate') }} </span>
         <span class="text-muted text-start"> {{ new Date().toLocaleString() }} </span>
       </div>
       <div class="d-flex flex-column">
         <span class="fw-bold fs-4 text-end"> {{ $t('recurrentExpense.label.endDate') }} </span>
         <span class="text-muted text-end"> {{ new Date().toLocaleString() }} </span>
       </div>
     </div>
   </div>
   <div>
     <h1 class="text-center my-10 fs-2hx"> {{ recurrentExpense.title }} </h1>
     <div style="min-height: 400px;">
       <div class="table-responsive px-5">
         <table class="table text-center table-rounded rounded-xl mb-5">
           <thead class="bg-light-primary">
           <tr class="py-3 rounded-5">
             <th>{{$t('recurrentExpense.label.reason')}}</th>
             <th>{{$t('recurrentExpense.label.amount')}}</th>
             <th>{{$t('recurrentExpense.label.currency')}}</th>
           </tr>
           </thead>
           <tbody>
           <Item v-for="(fee, index) in recurrentExpense?.recurrence_datas" :key="index" :fee="fee" :index="index" :currency="recurrentExpense?.currency?.symbol"/>
           </tbody>
           <tfoot class="bg-light-primary">
           <tr class="py-3 rounded-5">
             <td colspan="2" class="rounded-bottom rounded-bottom-5 text-start">
               <span class="fs-2x fw-bolder ms-10"> {{ $t('recurrentExpense.totalAmount') }} </span>
             </td>
             <td colspan="1">
               <span class="fs-2x fw-bolder text-primary"> {{ $formatLocalAmount(totalAmount) }} FCFA </span>
             </td>
           </tr>
           </tfoot>
         </table>
       </div>
     </div>
   </div>
  </div>
</template>

<script setup>
import {computed, defineProps} from 'vue'
import {useStore} from "vuex";
import {useLocales} from "@/composables/locales";
import Item from "./Item";
import {$formatLocalAmount} from "@/mixins/Helpers";

const { locale } = useLocales()
const store = useStore()

const props = defineProps({
  recurrentExpense: { type: Object, required: true }
})

const company = computed(() => store.getters['company/getCompanyInfos'])
const isActive = computed(() => props.recurrentExpense.status)
const totalAmount = computed(() =>
    props.recurrentExpense?.recurrence_datas?.reduce((acc, cur) => acc + parseFloat(cur.amount), 0) || 0
);

</script>

<style scoped>
  .container {
    width: 100%;
    max-width: 800px;
    margin: 20px auto;
    border: 1px solid #e0e0e0;
    border-radius: 5px;
  }

  thead tr {
    font-weight: 600;
  }
</style>
